import { DailyNavRecord } from 'api/models/DailyNavRecord';
import { DailyNavRecordUpdate } from 'api/models/DailyNavRecordUpdate';
import { DailyNavReportResponse } from 'api/models/DailyNavReportResponse';
import { DailyNavReportSourceResponse } from 'api/models/DailyNavReportSourceResponse';
import { DailyNavReviewNote } from 'api/models/DailyNavReviewNote';
import { DailyNavSendResponse } from 'api/models/DailyNavSendResponse';
import { DailyNavValidationResponse } from 'api/models/DailyNavValidationResponse';
import { FirmDailyNav } from 'api/models/FirmDailyNav';

export type { DailyNavReviewNote };
export type FirmDailyNavDay = FirmDailyNav & {
  // Instant Alexandria was queried as of for this NAV date. Finalize time when
  // the day is locked, otherwise that date's session close.
  market_data_as_of?: string | null;
};
export type DailyNavRecordWithDay = DailyNavRecord;
// From the generated client, not restated here: the backend declares status
// as a ChoiceField over DailyNavRecord.Status, so a value added there without
// a grid state for it stops compiling instead of falling through to a default.
export type DailyNavReviewStatus = DailyNavRecord.status;
// Same reason: the timing values are a backend enum, so a new one stops
// compiling here rather than being silently unhandled by the dialog.
export type DailyNavPriceAdjustmentTiming = DailyNavRecord.price_adjustment_timing;
// The read and update models generate SEPARATE enums. Values match today, so
// the boundary is explicit rather than implicit: if either side gains a value,
// this map stops compiling instead of silently sending an unmapped string.
export type DailyNavUpdatePriceAdjustmentTiming = DailyNavRecordUpdate.price_adjustment_timing;
export const TIMING_READ_TO_UPDATE: Record<DailyNavPriceAdjustmentTiming, DailyNavUpdatePriceAdjustmentTiming> = {
  [DailyNavRecord.price_adjustment_timing.TODAY]: DailyNavRecordUpdate.price_adjustment_timing.TODAY,
  [DailyNavRecord.price_adjustment_timing.NEXT_DAY]: DailyNavRecordUpdate.price_adjustment_timing.NEXT_DAY,
};
export type DailyNavValidationResult = DailyNavValidationResponse;
export type DailyNavReportPayload = DailyNavReportResponse;
export type DailyNavReportSourcePayload = DailyNavReportSourceResponse;
export type DailyNavSendResult = DailyNavSendResponse;
export type DailyNavReportSourceRow = DailyNavReportSourceResponse['rows'][number];
export type DailyNavValidationCheck = DailyNavValidationResponse['checks'][number];
export type DailyNavValidationCompany = DailyNavValidationCheck['companies'][number];
